import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await api.forgotPassword({ email });
    setMsg(res.message);
  };

  return (
    <div className="fp-wrapper">
      <div className="support-banner">
         <h1>Remote Desktop Support</h1>
       </div>
      <form className="fp-card" onSubmit={handleSubmit}>
        <h2>Forgot Password</h2>
        <p className="sub-text">
          Enter your registered email and we’ll send you a reset link.
        </p>

        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button className="primary-btn">Send Reset Link</button>

        {msg && <p className="success-msg">{msg}</p>}

        <p className="back-link" onClick={() => navigate("/")}>
          ← Back to Login
        </p>
      </form>
    </div>
  );
}